export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11884.f93b8832.jpg";